module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "title-form"
  }, [_vm._v("Datos de reserva")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Código de Reserva")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.params.code),
      callback: function($$v) {
        _vm.params.code = $$v
      },
      expression: "params.code"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "px-2": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Fecha de ingreso")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker menu-form",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuEnter),
      callback: function($$v) {
        _vm.menuEnter = $$v
      },
      expression: "menuEnter"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de ingreso",
      "append-icon": "event",
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.params.dateEnter),
      callback: function($$v) {
        _vm.params.dateEnter = $$v
      },
      expression: "params.dateEnter"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.validDate
    },
    model: {
      value: (_vm.params.dateEnter),
      callback: function($$v) {
        _vm.params.dateEnter = $$v
      },
      expression: "params.dateEnter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Fecha de salida")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker menu-form",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuOut),
      callback: function($$v) {
        _vm.menuOut = $$v
      },
      expression: "menuOut"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de salida",
      "append-icon": "event",
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.params.dateOut),
      callback: function($$v) {
        _vm.params.dateOut = $$v
      },
      expression: "params.dateOut"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "allowed-dates": _vm.allowedDatesOut,
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.params.dateOut),
      callback: function($$v) {
        _vm.params.dateOut = $$v
      },
      expression: "params.dateOut"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.status,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.params.state),
      callback: function($$v) {
        _vm.params.state = $$v
      },
      expression: "params.state"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-2": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Nº de Habitación")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.params.room),
      callback: function($$v) {
        _vm.params.room = $$v
      },
      expression: "params.room"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider-form"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('table-run', {
    staticClass: "no-selectable-table no-search-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-search": false,
      "selectable": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.customer.lastname) + ", " + _vm._s(props.row.customer.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.country.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.dateEnter))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.dateOut))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingRoom.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingRoom.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.occupiedRoom.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.mp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.anb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.company))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0673c61c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/bookings/Filter.vue
// module id = 1576
// module chunks = 76